import React from 'react'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'

const UpiLimitPopup = (props) => {
  const modalStyle = {
    borderBottom: "none",
    padding: "2rem 2rem 0 0",
    paddingTop : "8rem"
  }

  const modalBodyStyle = {
    marginTop: "1.5rem",
    paddingTop : "8rem"
  }

  const bodyStyle = {
    margin: "1rem 2rem !important",
    textAlign: "center",
    padding: "0 2rem"
  }

  return (
    <Modal 
      isOpen={props?.showUpiLimit} 
      toggle={props?.toggleUpiLimitPopup} 
      centered
      className='Upi-limit-popup'
      size='md'
      style={{marginTop : "10rem"}} 
    >
    <ModalHeader className='upi-limit-header'toggle={props?.toggleUpiLimitPopup}></ModalHeader>
      <ModalBody className='limit-body'>
        <div className='limit-content'>
          <p className='title'>You are allowed a maximum of ₹5 lakh in a single application in online mode</p>

          <div className='lists'>
            <li className='d-flex'>
              <p className='mb-0'><span class="mdi mdi-check-circle-outline check text-secondary mb-0"></span></p>
              <p className='points'>
                &nbsp;For investment amounts between ₹5-10 Lakh, you can apply in online 
                mode using multiple applications (i.e. by placing multiple transactions. 
                Refer image below)
              </p>
            </li>
            <li className='d-flex'>
              <p className='mb-0'><span class="mdi mdi-check-circle-outline check text-secondary mb-0"></span></p>
              <p className='points'>&nbsp;Maximum investment amount in online mode is ₹10 Lakh per PAN</p>
            </li>
          </div>

          {props?.img &&
          <div className='img-wrap'>
            <img src={props?.img} alt="ipoLimit" className='limit-img'/>
          </div>
          }
        </div>
      </ModalBody>
    </Modal>
  )
}

export default UpiLimitPopup